// Campaign renders receive customer/company/group context only, so template
// variables bound to a triggering event (a booking, a purchase, a game
// instance...) resolve to empty strings. This scans template content for
// those namespaces so the editor can warn before send.

// Namespace -> label shown in the warning. gift_card is the snake_case alias
// emitted by the visual gift card component; the variables panel inserts
// camelCase giftCard.
const EVENT_BOUND_NAMESPACES: Record<string, string> = {
  booking: 'booking',
  transaction: 'transaction',
  payment: 'payment',
  game: 'event',
  staff: 'staff',
  giftCard: 'gift card',
  gift_card: 'gift card',
  ticket: 'project ticket',
  log: 'activity log',
  automation: 'automation'
}

// The campaign worker aliases these to the customer's identity, so they
// render fine in campaigns and must not trigger the warning.
const CAMPAIGN_SAFE_TOKENS = new Set([
  'transaction.firstName',
  'transaction.lastName',
  'transaction.phone'
])

// Returns deduped, human-readable labels of event-bound namespaces whose
// variables appear in the template content and will render empty in a
// campaign send. Empty array = template is campaign-safe.
export function unresolvableVariableLabels(content: string): string[] {
  if (!content) return []
  const labels = new Set<string>()
  const tokenRe = /\{\{\s*([A-Za-z_]+)\.([A-Za-z_]+)/g
  let match
  while ((match = tokenRe.exec(content)) !== null) {
    const namespace = match[1]
    const label = EVENT_BOUND_NAMESPACES[namespace]
    if (!label) continue
    if (CAMPAIGN_SAFE_TOKENS.has(`${namespace}.${match[2]}`)) continue
    labels.add(label)
  }
  return Array.from(labels)
}

// Oxford-comma-free list: 'booking and event' / 'booking, payment and staff'
export function formatLabelList(labels: string[]): string {
  if (labels.length <= 1) return labels[0] || ''
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
}
